// Canonical gateway values shared by both quote screens.
export const PURPOSE_OPTIONS: Record<string, string> = Object.fromEntries(
  [
    "Лични нужди",
    "Фирмен автомобил за лична употреба",
    "Търговска дейност",
    "Друга фирмена дейност",
    "Производствена дейност",
    "Строителна дейност",
    "Международен транспорт",
    "Куриерски услуги",
    "Превоз на опасни товари",
    "За транспорт на пари и ценности",
    "Сметосъбиране",
    "Таксиметрова дейност",
    "Рент-а-кар",
    "Лизингов автомобил",
    "Учебен автомобил",
    "Охранителна дейност",
    "Полиция",
    "Линейка",
    "Пожарна",
    "Състезателен",
    "Друга дейност",
  ].map((p) => [p, p])
);
